import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import WhatsAppButton from './components/WhatsAppButton';
import { LanguageProvider } from './i18n/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './HomePage';
import About from './pages/About';
import Services from './pages/Services';
import References from './pages/References';
import International from './pages/International';
import Contact from './pages/Contact';
import ThankYou from './pages/ThankYou';
import CourantsForts from './pages/services/CourantsForts';
import CourantsFaibles from './pages/services/CourantsFaibles';
import EnergiesRenouvelables from './pages/services/EnergiesRenouvelables';
import MobiliteElectrique from './pages/services/MobiliteElectrique';
import RenovationEnergetique from './pages/services/RenovationEnergetique';
import ChauffageClimatisation from './pages/services/ChauffageClimatisation';
import VRD from './pages/services/VRD';
import BureauEtudes from './pages/services/BureauEtudes';
import LegalNotice from './pages/LegalNotice';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CGV from './pages/CGV';
import './App.css';
import SEO from './components/SEO';
function App() {
  return (
    <div className="App min-h-screen bg-white text-slate-900">
      <LanguageProvider>
        <BrowserRouter basename="/">
<SEO />
          <Header />

          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/references" element={<References />} />
            <Route path="/international" element={<International />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/thank-you" element={<ThankYou />} />

            <Route path="/services/courants-forts" element={<CourantsForts />} />
            <Route path="/services/courants-faibles" element={<CourantsFaibles />} />
            <Route path="/services/energies-renouvelables" element={<EnergiesRenouvelables />} />
            <Route path="/services/mobilite-electrique" element={<MobiliteElectrique />} />
            <Route path="/services/renovation-energetique" element={<RenovationEnergetique />} />
            <Route path="/services/chauffage-climatisation" element={<ChauffageClimatisation />} />
            <Route path="/services/vrd" element={<VRD />} />
            <Route path="/services/bureau-etudes" element={<BureauEtudes />} />
<Route path="/mentions-legales" element={<LegalNotice />} />
<Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
<Route path="/cgv" element={<CGV />} />
          </Routes>

          <Footer />
  <WhatsAppButton />
        </BrowserRouter>

      </LanguageProvider>
    </div>
  );
}

export default App;
